import {useFetchData} from 'hooks/api/useFetchData'
import {EmployeeDependent} from 'types/api/employees/employeeDependent'

export const useFetchEmployeeDependents = (employeeId: string) => {
  const path = `/api/employees/${employeeId}/employee_dependents`
  return useFetchData<EmployeeDependent[]>(path, [], {})
}
